import React from "react";
import { Box, Typography } from "@mui/material";

function Contact() {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h3" color="white">
        Contact
      </Typography>
    </Box>
  );
}

export default Contact;
